import { ICustomTextArea } from './types';
import styles from './customeTextArea.styles.module.scss'
import { Controller, useFormContext } from 'react-hook-form';


const CustomTextArea = (props: ICustomTextArea) => {
    const { label, placeholder, name, className, ...other } = props
    const { control } = useFormContext()
    return (
        <div className={`${styles.textAreaBox}`}>
            <label className="form-label">
                {label}
            </label>
            <Controller
                name={name}
                control={control}
                render={({ field }) => (
                    <textarea
                        className={`form-control ${className}`}
                        placeholder={placeholder}
                        {...field}
                        {...other}
                    />
                )}
            />
        </div>
    )
}

export default CustomTextArea